// "As of date" control (plan §9 AsOfBar, spec J10): rebuilds a page from the history as it was at
// the end of a chosen day (program time). While a date is set the page is read-only.
import { useId, useState, type FormEvent } from 'react';
import { formatLocal, isIsoDate, programDayStart } from '@cis/shared';

export function AsOfBar(props: {
  readonly asOf: string | undefined;
  /** The latest day that can be chosen: today in program time. */
  readonly max: string;
  readonly onChange: (asOf: string | undefined) => void;
}): React.JSX.Element {
  const id = useId();
  const [day, setDay] = useState(props.asOf ?? '');
  const valid = isIsoDate(day) && day <= props.max;
  const onSubmit = (event: FormEvent): void => {
    event.preventDefault();
    if (valid) props.onChange(day);
  };
  if (props.asOf !== undefined) {
    return (
      <div className="as-of as-of--on" role="status">
        <span>
          You are looking at this page as it was at the end of{' '}
          <strong>{formatLocal(programDayStart(props.asOf), 'date')}</strong>. Nothing can be
          changed here.
        </span>
        <button
          type="button"
          className="btn btn--secondary"
          onClick={() => props.onChange(undefined)}
        >
          Back to today
        </button>
      </div>
    );
  }
  return (
    <form className="as-of form-row" onSubmit={onSubmit} aria-label="Show an earlier day">
      <div className="field">
        <label className="field__label" htmlFor={id}>
          Show as it was on
        </label>
        <input
          id={id}
          className="field__input"
          type="date"
          max={props.max}
          value={day}
          onChange={(e) => setDay(e.target.value)}
        />
      </div>
      <button type="submit" className="btn btn--secondary" disabled={!valid}>
        Show
      </button>
    </form>
  );
}
